import React from "react";
import { createRoot } from "react-dom/client";
import { featureEnabled } from "feature-toggles!sofe";
import { handleError } from "../handle-error";
import { fetcher, onPusher } from "fetcher!sofe";
import Auth, { hasAccess } from "cp-client-auth!sofe";
import { first } from "rxjs/operators";

let root = null;

export default function () {
  return Promise.all([
    Auth.getLoggedInUserAsObservable().pipe(first()).toPromise(),
    Auth.getTenantAsObservable().pipe(first()).toPromise(),
  ]).then((values) => {
    const [loggedInUser, tenant] = values;
    if (loggedInUser && tenant) {
      const hasBillingAccess = hasAccess(loggedInUser)([
        "company_settings_billing",
        "billing_payments_create_edit",
      ]);

      if (hasBillingAccess) {
        return paymentsSweepDeactivatedBootstrap();
      }
    }
  });
}

async function paymentsSweepDeactivatedBootstrap() {
  if (!featureEnabled("toggle_shadow_deactivate_sweeps")) {
    return;
  }

  try {
    // Check initial sweep status
    await checkSweepStatus();

    // Subscribe to pusher events
    return onPusher("sweeps").subscribe((data) => {
      if (data.sweep_active === false) {
        showBankAccountIssueModal();
      }
    }, handleError);
  } catch (error) {
    handleError(error);
  }
}

async function showBankAccountIssueModal() {
  try {
    const paymentsUi = await SystemJS.import("payments-ui!sofe");

    if (!paymentsUi.getBankAccountIssueModal) {
      return;
    }

    const modalModule = await paymentsUi.getBankAccountIssueModal();
    if (!modalModule) {
      throw new Error(
        "Failed to load BankAccountIssueModal: getBankAccountIssueModal() returned undefined."
      );
    }

    const BankAccountIssueModal = modalModule.default;
    if (!BankAccountIssueModal) {
      throw new Error(
        "Failed to load BankAccountIssueModal: modalModule.default is undefined."
      );
    }

    const container = getOrCreateContainer();
    if (!root) {
      root = createRoot(container);
    }

    const handleClose = () => root.unmount();

    root.render(<BankAccountIssueModal show={true} onClose={handleClose} />);
  } catch (error) {
    handleError(error);
  }
}

function getOrCreateContainer() {
  let container = document.getElementById("payments-issue-modal-container");
  if (!container) {
    container = document.createElement("div");
    container.id = "payments-issue-modal-container";
    document.body.appendChild(container);
  }
  return container;
}

async function checkSweepStatus() {
  try {
    const { status } = await fetcher("/api/canopy_payments/onboarding/status");

    if (status?.sweep_status === false) {
      await showBankAccountIssueModal();
    }
  } catch (error) {
    handleError(error);
  }
}
